import {useState} from 'react'

const YouTube = (props) => {
    const [color, setColor] = useState(props.color)
    const hoverColorHandler = () => {setColor(props.hoverColor)}
    const resetColorHandler = () => {setColor(props.color)}

    return(
        <div onMouseOver={hoverColorHandler} onMouseLeave={resetColorHandler}>
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20"><path fill={color} d="M10.333 0c-5.522 0-10 4.478-10 10 0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10zm3.701 14.077c-1.752.12-5.653.12-7.402 0C4.735 13.947 4.514 13.018 4.5 10c.014-3.024.237-3.947 2.132-4.077 1.749-.12 5.651-.12 7.402 0 1.898.13 2.118 1.059 2.133 4.077-.015 3.024-.238 3.947-2.133 4.077zM8.667 8.048l4.097 1.949-4.097 1.955V8.048z"/></svg>
        </div>)
}

export default YouTube
